import { useEffect, useRef, useState } from "react";
import axios from "axios";
const API = process.env.REACT_APP_BACKEND_URL || "";

export default function ContinuityOptions({ pupilId }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const active = useRef(false);
  const request = useRef(null);
  const locked = useRef(false);
  useEffect(() => {
    active.current = true;
    return () => { active.current = false; request.current?.abort(); };
  }, []);
  const check = async () => {
    if (locked.current) return;
    locked.current = true; setLoading(true); setError(""); setResult(null);
    const controller = new AbortController(); request.current = controller;
    try {
      const { data } = await axios.get(`${API}/api/attention/lesson-continuity/${encodeURIComponent(pupilId)}/options`, { withCredentials: true, signal: controller.signal });
      if (!active.current) return;
      if (!Array.isArray(data?.options) || data.booked !== false) throw new Error("Unconfirmed options");
      setResult(data);
    } catch {
      if (active.current) setError("Lesson times could not be checked. You can try again. No booking has changed.");
    } finally {
      locked.current = false;
      if (active.current) setLoading(false);
    }
  };
  return <div className="pl-3 py-1 text-sm text-slate-700 dark:text-slate-300">
    <button type="button" disabled={loading} onClick={check} className="min-h-11 underline">{loading ? "Checking lesson times…" : "Check lesson times"}</button>
    {error && <p role="alert">{error}</p>}
    {result && <div aria-live="polite">
      <p>{result.message}</p>
      {result.options.length > 0 && <ul className="space-y-2 mt-2">{result.options.map(option => <li key={`${option.date}-${option.start_time}`}>
        <p>{option.date} · {option.start_time}–{option.end_time} · {option.duration_minutes} minutes</p>
        <p>{option.days_since_previous} days after the previous lesson{option.days_until_next !== null ? `; ${option.days_until_next} days before the next lesson` : ""}.</p>
        {option.longer_gap_remains && <p>A gap longer than the agreed interval would remain.</p>}
      </li>)}</ul>}
      {result.state === "options_found" && <p className="mt-2">Regular time on the road helps maintain experience and routine. These are options to discuss with the pupil.</p>}
      {result.search_complete === false && <p>Further dates have not all been checked.</p>}
    </div>}
  </div>;
}
